import React, { useEffect, useState } from "react";
import AccordionComponent from "./accordion/AccordionComponent";
import CardComponent from "./cardComponents/CardComponent";
import { CiGlobe } from "react-icons/ci";
import { TbTransfer } from "react-icons/tb";
import { PiGlobeHemisphereWestLight } from "react-icons/pi";
import { MdOutlinePermContactCalendar } from "react-icons/md";
import LoanCardComponent from "./loadCardComponent/LoanCardComponent";
import CrouselComponent from "./CarouselComponent/CrouselComponent";
import { MdGavel } from "react-icons/md";
import { GiTakeMyMoney } from "react-icons/gi";
import { BsBook, BsCalculator, BsFillPersonCheckFill, BsPeople } from "react-icons/bs";
import { FaTools } from "react-icons/fa";
import Http from "../Http";
import { CARD_API } from "../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Newsletter from "./contact/Newsletter";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { motion } from "framer-motion";
import MortgageRates from "./HomeComponents/MortgageRates";
import { Crown, Search, User } from "lucide-react";
import { Sparkle, Star, ThumbsUp, Trophy, ShieldCheck } from "lucide-react";
import { Scale, BookOpenCheck, LifeBuoy } from "lucide-react";
import { TrendingUp, BookOpen, BadgePercent, EyeOff } from "lucide-react";
import HomeBlog from "./blog/HomeBlog";
import AdBanner from "./AdPage/AdBanner";
import BrandSpotlight from "./AdPage/BrandSpotlight";

const Home = () => {
  // const [CreditCardData, setCreditCardData] = useState([])
  // const [currentPage, setCurrentPage] = useState(1);
  // const [cardsPerPage] = useState(10);
  // const [currentPage_Personal, setCurrentPagePersonal] = useState(1);
  // const [cardsPerPage_Personal] = useState(10);
  // useEffect(() => {
  //     Http.post(CARD_API).then((res) => {
  //         setCreditCardData(res)
  //     }).catch((err) => {
  //         console.log(err)
  //     })
  // }, [])
  // const indexOfLastCard = currentPage * cardsPerPage;
  // const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  // console.log({ indexOfLastCard, indexOfFirstCard })
  // const currentCards = CreditCardData.cards?.filter((card) => card.category === "Credit card").slice(indexOfFirstCard, indexOfLastCard);
  // console.log({ currentCards })

  // const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // const indexOfLastCard_Personal = currentPage_Personal * cardsPerPage_Personal;
  // const indexOfFirstCard_Personal = indexOfLastCard_Personal - cardsPerPage;
  // console.log({ indexOfLastCard, indexOfFirstCard_Personal })
  // const currentCards_Personal = CreditCardData.cards?.filter((card) => card.category === "Loan").slice(indexOfFirstCard_Personal, indexOfLastCard_Personal);
  // console.log({ currentCards })
  // const paginatePersonal = (pageNumber) => setCurrentPagePersonal(pageNumber);
  const products1 = [
    {
      title: "Term Life Insurance",
      discount: "",
      icon: "🛡️",
      link: "/termlife-insurance",
    },
    {
      title: "Health Insurance",
      discount: "FREE Home Visit",
      icon: "❤️",
      link: "/health-insurance",
    },
    {
      title: "Car Loan",
      discount: "In-Built Life Cover",
      icon: "🚗",
      link: "/car-loan",
    },
    {
      title: "Car Insurance",
      discount: "",
      icon: "🛻",
      link: "/car-insurance",
    },
    {
      title: "2 Wheeler Insurance",
      discount: "",
      icon: "🏍️",
      link: "/bike-insurance",
    },

    {
      title: "Travel Insurance",
      // discount: "",
      icon: "🧳",
      link: "/travel-insurance",
    },
    {
      title: "Home Loan",
      // discount: "Upto 20% Cheaper",
      icon: "🏠",
      link: "/home-loan",
    },
    {
      title: "Gold Loan",
      //  discount: "",
      icon: "👑",
      link: "/gold-loan",
    },
    {
      title: "Fuel Cards",
      discount: "",
      icon: "⛽",
      link: "/credit-card/fuel-credit-card",
    },
    {
      title: "Personal Loan",
      discount: "",
      icon: "🧾",
      link: "/personal-loan",
    },
    {
      title: "Demat Accounts",
      discount: "",
      icon: "📈",
      link: "/demat",
    },
    {
      title: "Premium Cards",
      discount: "",
      icon: "💎",
      link: "/credit-card/best-premium-credit-card",
    },
    {
      title: "CashBack Cards",
      discount: "",
      icon: "💰",
      link: "/credit-card/best-cashback-credit-card",
    },
    {
      title: "Education Loan",
      discount: "",
      icon: "🎓",
      link: "/education-loan",
    },
    {
      title: "Life Time Free Card",
      discount: "",
      icon: "💳",
      link: "/credit-card/best-lifetime-free-credit-cards",
    },
    {
      title: "Business Loan",
      discount: "",
      icon: "🏢",
      link: "/business-loan",
    },
  ];

  const calculators = [
    {
      title: "Investment & Returns Calculators",
      bgColor: "bg-gradient-to-r from-pink-500 to-red-500",
      textColor: "text-white",
      icon: "📊",
      links: [
        {
          name: "SIP Returns Calculator",
          path: "/financial-tools-calculators/sip-calculator",
        },
        {
          name: "Lumpsum Returns Calculator",
          path: "/financial-tools-calculators/lumpsum-calculator",
        },
        {
          name: "Mutual Fund Returns Calculator",
          path: "/financial-tools-calculators/mutual-fund-calculator",
        },
        {
          name: "Step Up SIP Calculator",
          path: "/financial-tools-calculators/step-up-sip-calculator",
        },
      ],
    },
    {
      title: "Loan & EMI Calculators",
      bgColor: "bg-gradient-to-r from-blue-500 to-indigo-500",
      textColor: "text-white",
      icon: "🧮",
      links: [
        {
          name: "EMI Calculator",
          path: "/financial-tools-calculators/emi-calculator",
        },
        {
          name: "Car Loan EMI Calculator",
          path: "/financial-tools-calculators/car-loan-emi-calculator",
        },
        {
          name: "Home Loan EMI Calculator",
          path: "/financial-tools-calculators/home-loan-emi-calculator",
        },
        {
          name: "Flat vs Reducing Rate Calculator",
          path: "/financial-tools-calculators/flat-vs-reducing-rate-calculator",
        },
      ],
    },
    {
      title: "Financial Tools & Misc. Calculators",
      bgColor: "bg-gradient-to-r from-purple-500 to-violet-500",
      textColor: "text-white",
      icon: "💼 ",
      links: [
        {
          name: "CAGR Calculator",
          path: "/financial-tools-calculators/cagr-calculator",
        },
        {
          name: "GST Calculator",
          path: "/financial-tools-calculators/gst-calculator",
        },
        {
          name: "NSC Calculator",
          path: "/financial-tools-calculators/nsc-calculator",
        },
        {
          name: "Brokerage Calculator",
          path: "/financial-tools-calculators/brokerage-calculator",
        },
      ],
    },
  ];

  const slides = [
    {
      title: "Smart Budgeting Tool",
      description:
        "Track expenses, set budgets & stay on top of your financial health.",
      boldText: "Start budgeting",
      bgColor: "from-purple-500 to-pink-500",
      icon: "🧠",
      link: "/financial-tools-calculators",
    },
    {
      title: "Compare Credit Cards",
      description:
        "Explore rewards, benefits & fees tailored to your lifestyle.",
      boldText: "Find the Perfect Card in Minutes",
      bgColor: "from-blue-500 to-cyan-500",
      icon: "💳",
      link: "/credit-card",
    },
    {
      title: "Loan EMI Calculator",
      description:
        "Calculate EMIs for personal, home, or car loans in seconds using this simple tool.",
      boldText: "Know Your Monthly Outflow",
      bgColor: "from-red-500 to-pink-500",
      icon: "🏦",
      link: "/financial-tools-calculators/emi-calculator",
    },
    {
      title: "Mutual Fund Calculator",
      description:
        "Quickly see how much your SIP or lump sum investments could yield.",
      boldText: "Forecast Your Investment Growth",
      bgColor: "from-purple-500 to-pink-500",
      icon: "📈",
      link: "/financial-tools-calculators/mutual-fund-calculator",
    },
    {
      title: "Compare Loans",
      description:
        "Analyze interest rates, processing fees, tenures, and benefits from top loan providers — all in one place.",
      boldText: "Choose Smarter, Borrow Better",
      bgColor: "from-blue-500 to-cyan-500",
      icon: "🏦",
      link: "/car-loan",
    },
    {
      title: "Tax-Saving Calculator",
      description: "Discover smart ways to save tax while meeting life goals.",
      boldText: "Maximize Your Returns, Minimize Your Tax",
      bgColor: "from-red-500 to-pink-500",
      icon: "🧾",
      link: "/financial-tools-calculators",
    },
  ];

  const creditProducts = [
    {
      title: "CREDIT CARDS",
      description:
        "From 50+ Options, Choose a card matching your lifestyle & needs",
      linkText: "Get Best Offers",
      icon: "💳",
    },
    {
      title: "PERSONAL LOAN",
      description:
        "Select the best offer curated just for you from a wide choice of Banks & NBFC's",
      linkText: "Check Eligibility",
      icon: "💵",
    },
    {
      title: "MICRO LOANS (UNDER ₹50K)",
      description:
        "Instant small ticket loans to meet your immediate cash needs",
      linkText: "Get Instant Loan",
      icon: "🤲",
    },
    {
      title: "BUSINESS LOAN",
      description: "Expand your business with loans at low interest rates",
      linkText: "Check Eligibility",
      icon: "📁",
    },
    {
      title: "TRANSFER PERSONAL LOAN",
      description: "Get better interest rates on your existing personal loan",
      linkText: "Reduce Your EMI",
      icon: "💰",
    },
    {
      title: "HOME LOAN",
      description:
        "Choose from lowest interest rates available for your dream home",
      linkText: "Check Eligibility",
      icon: "🏠",
    },
    {
      title: "LOAN AGAINST PROPERTY",
      description: "Get liquidity against your property at best interest rates",
      linkText: "Check Eligibility",
      icon: "🏡",
    },
    {
      title: "TRANSFER HOME LOAN",
      description: "Get better interest rates on your existing home loan",
      linkText: "Reduce Your EMI",
      icon: "🔄",
    },
    {
      title: "GOLD LOAN",
      description:
        "Get loan against your gold at best interest rates with our doorstep service",
      linkText: "Know More",
      icon: "🏅",
    },
    {
      title: "LOAN AGAINST MUTUAL FUNDS",
      description: "Get best loan offer against your mutual fund portfolio",
      linkText: "Apply Now",
      icon: "📈",
    },
  ];
  const DematProducts = [
    {
      title: "CREDIT CARDS",
      description:
        "From 50+ Options, Choose a card matching your lifestyle & needs",
      linkText: "Get Best Offers",
      icon: "💳",
    },
    {
      title: "PERSONAL LOAN",
      description:
        "Select the best offer curated just for you from a wide choice of Banks & NBFC's",
      linkText: "Check Eligibility",
      icon: "💵",
    },
    {
      title: "MICRO LOANS (UNDER ₹50K)",
      description:
        "Instant small ticket loans to meet your immediate cash needs",
      linkText: "Get Instant Loan",
      icon: "🤲",
    },
  ];

  const features = [
    {
      title: "Make confident decisions",
      desc: "Forget the second-guessing. With FinMaster guiding you through the numbers and fine print, you can compare with clarity and make calls that feel right.",
      icon: <ShieldCheck className="w-6 h-6" />,
      color: "from-purple-500 to-fuchsia-600",
    },
    {
      title: "Reach your goals faster",
      desc: "Whether it's buying a car, clearing debt, or stacking up savings—comparing the market helps you move smarter. FinMaster shows you the shortcuts, minus the guesswork.",
      icon: <TrendingUp className="w-6 h-6" />,
      color: "from-red-400 to-amber-500",
    },
    {
      title: "Stay ahead of trends",
      desc: "The market’s always moving—and the smart ones move with it. FinMaster keeps you in the loop so you can catch a great opportunity before everyone else jumps in.",
      icon: <Trophy className="w-6 h-6" />,
      color: "from-green-400 to-emerald-600",
    },
    {
      title: "Knowledge is your biggest asset",
      desc: "Understanding the market puts you in control. Whether you're looking to invest, borrow, or a better deal—knowing the game helps you play it smarter. FinMaster’s got your back with simple breakdowns and sharp insights.",
      icon: <BookOpen className="w-6 h-6" />,
      color: "from-pink-500 to-yellow-500",
    },
    {
      title: "Find the best value, always",
      desc: "When you compare, you don’t just go with what’s easy—you go with what’s worth it. From credit cards to insurance, FinMaster helps you weigh your options and score the best bang for your buck.",
      icon: <BadgePercent className="w-6 h-6" />,
      color: "from-cyan-500 to-indigo-500",
    },

    {
      title: "Avoid hidden traps",
      desc: "Not everything that shines is gold. Comparing lets you dodge sketchy deals, spot hidden fees, and keep your money where it matters. FinMaster breaks it down so nothing slips past you.",
      icon: <EyeOff className="w-6 h-6" />,
      color: "from-orange-400 to-amber-500",
    },
  ];
  const pbAdvantages = [
    {
      title: "Transparent Comparisons",
      desc: "We break down financial products into clear, side-by-side comparisons — no fluff, no bias.",
      icon: <Scale className="text-4xl text-blue-600" />,
    },
    {
      title: "Smart Recommendations",
      desc: "Our insights are driven by real-time data and user needs — not commissions or sales goals.",
      icon: <ThumbsUp className="text-4xl text-blue-600" />,
    },
    {
      title: "Financial Learning Made Easy",
      desc: "We explain the “why” behind every financial move through blogs, guides, and quick reads.",
      icon: <BookOpenCheck className="text-4xl text-blue-600" />,
    },
    {
      title: "Always on Your Side",
      desc: "From discovery to decision — FinMaster stays with you, offering updates, alerts, and advice whenever you need it.",
      icon: <LifeBuoy className="text-4xl text-blue-600" />,
    },
  ];
  const ad = {
    image: "/assets/homeadd.png",
    link: "https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share",
    altText: "Advertisement",
  };
  const ad2 = {
    image: "/assets/popad.png",
    link: "https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share",
    altText: "Advertisement",
  };
  const ads3 = [
    {
      id: 1,
      image: "/assets/slider.png",
      link: "https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share",
    },
    {
      id: 2,
      image: "/assets/slider.png",
      link: "https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share",
    },
    {
      id: 3,
      image: "/assets/slider.png",
      link: "https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share",
    },
  ];

  const [currentAd, setCurrentAd] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAd((prev) => (prev + 1) % ads3.length);
    }, 4000); // Change every 4 seconds

    return () => clearInterval(interval);
  }, [ads3.length]);
  return (
    <>
      <Helmet>
        <title>
          Finmaster - Your Go-To Platform for Financial Education, Loan Guides,
          Insurance Tips & Credit Card Tools
        </title>
        <meta
          name="description"
          content="Finmaster is your all-in-one platform for personal finance. Get expert advice on loans, credit cards, insurance, Demat accounts & financial planning. Compare, learn & take control of your money."
        />
        <meta
          name="keywords"
          content="insurance comparison, compare car insurance, compare bike insurance, compare health insurance, life insurance comparison, compare credit cards, compare loan"
        />
        <link rel="canonical" href="https://thefinmaster.com/" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <section
        className="pt-24 lg:pt-32 bg-center bg-cover"
        style={{ backgroundImage: "url('/assets/bghome.png')" }}
      >
        {/* <section class="pt-8 lg:pt-32 bg-[url('https://pagedone.io/asset/uploads/1691055810.png')] bg-center bg-cover"> */}
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative text-center ">
          <div class=" border border-indigo-600 p-1 w-60 mx-auto rounded-full flex items-center justify-between mb-4">
            <span class=" text-sm font-medium text-gray-900 ml-8 ">
              Start Your Financial Journey
            </span>
          </div>
          <h1 class="max-w-2xl mx-auto text-center  font-bold text-3xl text-gray-900 mb-2 md:text-5xl leading-[30px]">
            Master Your Money with the Power of
            <span class="text-blue-500"> Smart Finance </span>
          </h1>
          <p class="max-w-sm mx-auto text-center text-base font-normal leading-7 text-gray-500 mb-2">
            From Credit Cards to Investments — Discover tools, insights, and
            guidance to build your financial future with confidence.
          </p>
          <a
            href="/contact-us"
            class="w-full md:w-auto mb-14 inline-flex items-center justify-center py-3 px-7 text-base font-semibold text-center text-white rounded-full bg-blue-600 shadow-xs hover:bg-blue-700 transition-all duration-500"
            // target="blank"
            // rel="nofollow"
          >
            Sign Up Now
            <svg
              class="ml-2"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 15L11.0858 11.4142C11.7525 10.7475 12.0858 10.4142 12.0858 10C12.0858 9.58579 11.7525 9.25245 11.0858 8.58579L7.5 5"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>

          {/* <Link
            to="https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
          > */}
            <div class="flex justify-center">
            <AdBanner displayOrder="1" />
            </div>
          {/* </Link> */}
        </div>
      </section>
      {/* <section className="md:pt-24 sm:pt-10 pt-10 lg:pt-32 bg-center bg-cover">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col-reverse lg:flex-row items-center gap-10">
           
          

           
            <div className="w-full lg:w-1/2 flex justify-center">
            <AdBanner displayOrder="2" />
            
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <div className="border border-indigo-600 p-1 w-60 mx-auto lg:mx-0 rounded-full flex items-center justify-center mb-4">
                <span className="text-lg font-medium text-gray-900">
                  Brand Spotlight
                </span>
              </div>
              <h1 className="font-bold text-3xl md:text-5xl text-gray-900 leading-[30px] mb-5">
                Save Up to ₹2,000 Monthly with
                <span className="text-blue-500"> Smarter Money Moves</span>
              </h1>
              <p className="text-base font-normal leading-7 text-gray-500 mb-8">
                Enjoy discounts on your spends
              </p>
             
            </div>

          </div>
        </div>
      </section> */}
<BrandSpotlight />
      <div className="w-full">
        {/* <div className="w-full flex flex-col items-center"> */}
        {/* <div className='w-full h-screen flex justify-center relative bg-black'>
                        <div className='w-[90%] z-20 flex flex-wrap md:flex-nowrap justify-center'>
                            <div className='w-full flex items-center'>
                                <div className='md:w-[80%] z-30'>
                                    <h1 className='font-bold text-4xl md:text-6xl text-white text-center md:text-start'>
                                        Welcome to TheFinMaster
                                    </h1>
                                    <p className='text-gray-100 py-5 font-medium text-xl text-center md:text-start'>
                                        Find, Compare, and Apply for the Ideal
                                        <p className='text-gray-100  font-medium text-xl text-center md:text-start'>Product Tailored to Your Needs!</p>
                                    </p>

                                    <div className='flex justify-center md:justify-start'>
                                        <button className='px-8 py-4 rounded-full bg-blue-600 shadow-lg text-white font-medium mt-2 text-lg'>Get Your Card</button>
                                    </div>
                                </div>
                            </div>

                            <div className='md:w-full z-30 md:flex mt-5 items-center justify-center'>
                                <video autoPlay muted loop className='mix-blend-exclusion'>
                                    <source src='/heroGif.mp4' type='video/mp4'></source>
                                </video>
                            </div>
                        </div>
                    </div> */}

        {/* <div className='w-[95%] my-10'>
                        <h2 className='text-4xl font-bold text-center  pb-3'>Your Financial Solutions</h2>

                        <p className='text-xl text-center  text-blue-600'>Everything You Need Under One Roof</p>

                        <div className='w-full flex flex-wrap md:flex-nowrap gap-8 py-10'>

                            <div className='w-full border border-b-4 border-b-blue-600 hover:border-b-black shadow-lg hover:shadow-2xl'>
                                <Link to="/car-loan">
                                    <div className='w-full h-[250px] overflow-hidden'>
                                    <figure className='relative w-full h-full'>
                                        <img className='w-[100%] h-[100%] object-cover hover:scale-110 duration-150' src='../assets/loanhomepage.webp' alt='Image of a home loan calculator with features for comparing loan policies, exploring auto loans, and getting pre-approved.' />
                                        <figcaption>
                                        <span className='sr-only' aria-hidden="true">  Get a Loan, Compare Loan Policy! Explore auto loans with competitive rates & flexible terms. Get pre-approved today!</span>

                                        </figcaption>
                                           </figure>
                                    </div>
                                </Link>
                                <div className='p-5'>
                                    <h1 className='text-lg font-medium'>Loans:</h1>
                                    <p className='text-sm text-gray-600 pt-2'>
                                        <ul className="list-disc list-inside">
                                            <li>Your Gateway to Financial Flexibility: Discover various loan products.</li>
                                            <li>From Auto to Home Loan: Explore a wide array of loan options.</li>
                                            <li>Fulfill Your Financial Goals: Learn how loans can help you achieve your dreams.</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>

                            <div className='w-full border border-b-4 border-b-blue-600 hover:border-b-black shadow-lg hover:shadow-2xl'>
                                <Link to="/credit-card" >
                                    <div className='w-full h-[250px] overflow-hidden'>
                                    <figure className='relative w-full h-full'>
                                        <img className='w-[100%] h-[100%] object-cover hover:scale-110 duration-150' src='../assets/cardhome.webp' alt='Image of Mastercard credit cards. Get Credit Card, Compare Credit card. Snack on this & consider credit cards for cash back, travel points & more!' />
                                        <figcaption >
                                        <span className='sr-only' aria-hidden="true">  Image of Mastercard credit cards. Get Credit Card, Compare Credit card. Snack on this & consider credit cards for cash back, travel points & more!</span>
                                        </figcaption>
                                           </figure>
                                    </div>
                                </Link>
                                <div className='p-5'>
                                    <h1 className='text-lg font-medium'>Credit Cards:



                                    </h1>
                                    <p className='text-sm text-gray-600 pt-2'>
                                        <ul className="list-disc list-inside">
                                            <li>Unlock the Power of Plastic: Learn About Diverse Range of Credit Cards.</li>
                                            <li>Explore Various Credit Card Options Suited to Your Spending Habits.</li>
                                            <li>Find the Perfect Card for You: Compare Features, Rewards & Benefits.</li>
                                        </ul>
                                    </p>
                                </div>

                            </div>
                            <div className='w-full border border-b-4 border-b-blue-600 hover:border-b-black shadow-lg hover:shadow-2xl'>
                                <Link to="/demat">
                                    <div className='w-full h-[250px] overflow-hidden'>
                                    <figure className='relative w-full h-full'>
                                        <img className='w-[100%] h-[100%] object-cover hover:scale-110 duration-150' src='../assets/demathome.webp' alt='Get a Demat Account, Compare Deamt Accounts. Track investments, view real-time quotes, manage portfolio. Learn about Demat & Trading A/cs.' />
                                        <figcaption>
                                        <span className='sr-only' aria-hidden="true">  Track investments on your phone! See real-time quotes & manage your portfolio. Curious about Demat & Trading A/cs? Learn more!</span>
                                        </figcaption>
                                           </figure>
                                    </div>
                                </Link>
                                <div className='p-5'>
                                    <h1 className='text-lg font-medium'>Demat:</h1>
                                    <p className='text-sm text-gray-600 pt-2'>
                                        <ul className="list-disc list-inside">

                                            <li>Manage Your Investments: Learn About Demat Account Services.</li>
                                            <li>Ease Investments: Discover Demat Account Benefits.</li>
                                            <li>Invest Confidently: Find the Ideal Demat Account for Portfolio Growth.</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>
                            <div className='w-full border border-b-4 border-b-blue-600 hover:border-b-black shadow-lg hover:shadow-2xl'>
                                <Link to="/car-insurance">
                                    <div className='w-full h-[250px] overflow-hidden'>
                                    <figure className='relative w-full h-full'>
                                        <img className='w-[100%] h-[100%] object-cover hover:scale-110 duration-150' src='../assets/insurancehome.webp' alt='Compare and Apply For Insurance. Secure your future with quotes for car, bike, life & travel insurance online.' />
                                        <figcaption>
                                        <span className='sr-only' aria-hidden="true">Secure your future!  Get quotes for car, bike, life & travel insurance online. Protect what matters most,</span>
                                        </figcaption>
                                           </figure>
                                    </div>
                                </Link>
                                <div className='p-5'>
                                    <h1 className='text-lg font-medium'>Insurance:</h1>
                                    <p className='text-sm text-gray-600 pt-2'>
                                        <ul className="list-disc list-inside">

                                            <li>Secure Your Future: Explore Comprehensive Insurance Offerings.</li>
                                            <li>Protect What Matters: Discover Insurance Plans Tailored to Your Needs.</li>
                                            <li>Find the Right Insurance Coverage for You and Your Loved Ones.</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>

                        </div>

                    </div> */}

        <div className="container mx-auto px-6 lg:py-10 md:py-10  py-2 sm:py-2 ">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800">
            Popular Calculators
          </h2>
          <p className="text-gray-600 text-center mt-3 max-w-2xl mx-auto">
            Explore our easy-to-use calculators designed to assist you in making
            informed financial decisions.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
            {calculators.map((calc, index) => (
              <div
                key={index}
                className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition duration-300"
              >
                <div
                  className={`p-5 ${calc.bgColor} flex items-center justify-between`}
                >
                  <h3 className={`text-lg font-semibold ${calc.textColor}`}>
                    {calc.title}
                  </h3>
                  <span className="text-3xl">{calc.icon}</span>
                </div>
                <ul className="p-5 bg-white space-y-3">
                  {calc.links.map((link, idx) => (
                    <li key={idx} className="border-b pb-2 last:border-none">
                      <Link
                        to={link.path}
                        className="flex justify-between items-center text-gray-700 hover:text-blue-500 transition duration-200"
                      >
                        {link.name} <span>&rarr;</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
       
          {/* <div className="text-center mt-10">
        <Link to="/all-calculators">
          <button className="px-6 py-3 bg-blue-600 text-white font-medium rounded-full shadow-lg hover:bg-blue-700 transition duration-300">
            View All Calculators
          </button>
        </Link>
      </div> */}
        </div>

        {/* <div className="w-full flex justify-center items-center py-6 px-4">
          <Swiper
            slidesPerView={1.2}
            spaceBetween={15}
            autoplay={{ delay: 3000, disableOnInteraction: false }} // Auto slide enabled
            // pagination={{
            //   clickable: true,
            //   renderBullet: (index, className) =>
            //     `<span class="${className} w-3 h-3 bg-gray-500 opacity-75 rounded-full"></span>`,
            // }}
            breakpoints={{
              640: { slidesPerView: 1.5 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            modules={[Pagination, Autoplay]}
            className="w-full max-w-6xl"
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index}>
                <div
                  className={`bg-gradient-to-r ${slide.bgColor} p-6 rounded-xl text-white shadow-md flex flex-col justify-between h-44`}
                >
                  <div className="flex items-center gap-2">
                    <span className="text-2xl">{slide.icon}</span>
                    <p className="text-sm">{slide.title}</p>
                  </div>
                  <p className="text-lg">
                    {slide.description}{" "}
                    <span className="font-bold">{slide.boldText}</span>
                  </p>
                  {slide.buttonText && (
                    <button className="bg-white text-blue-600 px-3 py-1 rounded-lg font-medium mt-2 w-max">
                      {slide.buttonText}
                    </button>
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div> */}
        <div className="w-full flex justify-center items-center py-2 px-4">
          <Swiper
            slidesPerView={1.2}
            spaceBetween={20}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            breakpoints={{
              640: { slidesPerView: 1.5 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            modules={[Autoplay]}
            className="w-full max-w-6xl"
          >
            {slides.map((slide, index) => (
              // <SwiperSlide key={index} className="flex justify-center">
              //   <a
              //     href={slide.link}
              //     className={`w-full max-w-sm bg-gradient-to-r ${slide.bgColor} p-6 rounded-xl text-white shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-xl min-h-[180px] flex flex-col gap-y-3`}
              //   >
              //     <div className="flex items-center gap-2">
              //       <span className="text-2xl">{slide.icon}</span>
              //       <p className="text-sm font-semibold">{slide.title}</p>
              //     </div>
              //     <p className="text-base leading-snug">
              //       {slide.description}{" "}
              //       <span className="font-bold">{slide.boldText}</span>
              //     </p>
              //   </a>
              // </SwiperSlide>
              <SwiperSlide key={index} className="flex justify-center h-full">
  <a
    href={slide.link}
    className={`w-full max-w-sm bg-gradient-to-r ${slide.bgColor} p-6 rounded-xl text-white shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-xl min-h-[200px] h-full flex flex-col gap-y-3`}
  >
    <div className="flex items-center gap-2">
      <span className="text-2xl">{slide.icon}</span>
      <p className="text-sm font-semibold">{slide.title}</p>
    </div>
    <p className="text-base leading-snug">
      {slide.description}{" "}
      <span className="font-bold">{slide.boldText}</span>
    </p>
  </a>
</SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="block max-w-[728px] w-full">
        <AdBanner displayOrder="3" />
        </div>
            {/* <a
              href={ads3[currentAd].link}
              target="_blank"
              rel="noopener noreferrer"
              className="block max-w-[728px] w-full"
            >
              <img
                src={ads3[currentAd].image}
                alt={`Ad ${currentAd + 1}`}
                className="w-full h-auto object-contain rounded-md shadow-md transition duration-300"
              />
            </a> */}
          </div>
        <div className="relative w-full bg-white lg:pt-8 md:pt-8 sm:pt-0 pb-20 overflow-hidden">
          {/* Floating dots and blobs background */}
          <div className="absolute inset-0 opacity-10 z-0">
            <div className="absolute top-0 left-0 w-24 h-24 rounded-full border border-pink-200 animate-pulse"></div>
            <div className="absolute bottom-20 left-8 w-3 h-3 rounded-full bg-pink-200 animate-bounce"></div>
            <div className="absolute top-16 right-16 w-3 h-3 rounded-full bg-pink-200 animate-ping"></div>
            <div className="absolute bottom-32 right-24 w-4 h-4 rounded-full bg-pink-200 animate-pulse"></div>
          </div>

          <div className="absolute -left-24 top-1/4 w-64 h-64 rounded-full bg-blue-50 opacity-50 blur-3xl"></div>

          <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-start justify-between relative z-10">
            {/* Left Side Content */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="w-full md:w-1/2 mb-12 md:mb-0 mt-4"
            >
              <div className="max-w-md">
                <h2 className="md:text-4xl text-2xl font-normal text-gray-700 ">
                  What makes
                </h2>
                <h2 className="md:text-4xl text-2xl font-bold text-slate-800 ">
                  The Finmaster
                </h2>
                <h2 className="md:text-4xl text-2xl font-normal text-slate-700 ">
                  one of India's
                </h2>
                <h2 className="md:text-4xl text-2xl font-normal text-slate-700 ">
                  go-to hubs for
                </h2>
                <h2 className="md:text-4xl text-2xl font-normal text-slate-700 ">
                  <span className="font-bold"> smart financial choices</span>?
                </h2>
              </div>
            </motion.div>

            {/* Feature Cards */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="w-full md:w-1/2 grid grid-cols-1 md:grid-cols-2 gap-6"
            >
              {[
                {
                  icon: "🧠",
                  title: "30+ Smart Tools & Guides",
                  desc: "From calculators to comparison engines, explore a suite of tools to simplify your financial decisions.",
                  color: "text-amber-500",
                  titleColor: "text-blue-700",
                },
                {
                  icon: "🏦",
                  title: "50+ Banks & Insurers Compared",
                  desc: "We bring multiple providers under one roof—so you get to choose what works best for you.",
                  color: "text-blue-500",
                  titleColor: "text-cyan-500",
                },
                {
                  icon: "📚",
                  title: "New Content Added Weekly",
                  desc: "Fresh insights, expert guides, and updated product data to help you stay financially sharp.",
                  color: "text-green-500",
                  titleColor: "text-green-500",
                },
                {
                  icon: "📄",
                  title: "500+ Plans Analyzed",
                  desc: "Across credit cards, loans, insurance, and investments—so you always make informed choices.",
                  color: "text-yellow-500",
                  titleColor: "text-yellow-500",
                },
              ].map((card, i) => (
                <motion.div
                  key={i}
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-2xl transition-shadow"
                >
                  <div className={`mb-4 ${card.color}`}>
                    <span className="text-3xl">{card.icon}</span>
                  </div>
                  <h3
                    className={`${card.titleColor} font-semibold text-xl mb-2`}
                  >
                    {card.title}
                  </h3>
                  <p className="text-gray-700">{card.desc}</p>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>

        <div className="w-full flex justify-center items-center my-2 px-4">
<div className="w-full max-w-5xl">
        <AdBanner displayOrder="4" />
        </div>
          {/* <a
            href={ad.link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full max-w-5xl"
          >
            <img
              src={ad.image}
              alt={ad.altText}
              className="w-full h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105"
            />
          </a> */}
        </div>
        {/* <section className="p-6 md:p-12">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 border-b-2 border-blue-500 pb-2 mb-6">
            CREDIT PRODUCTS
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {creditProducts.map((product, index) => (
              <motion.div
                key={index}
                className="bg-white shadow-lg rounded-lg p-5 flex flex-col gap-3 transition-all transform hover:scale-105"
                whileHover={{ scale: 1.05 }}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <div className="text-4xl">{product.icon}</div>
                <h3 className="text-lg font-bold text-blue-800">
                  {product.title}
                </h3>
                <p className="text-gray-600">{product.description}</p>
                <a
                  href="#"
                  className="text-blue-600 font-medium flex items-center hover:underline"
                >
                  {product.linkText} →
                </a>
              </motion.div>
            ))}
          </div>
        </section> */}
        {/* <section className="p-6 md:p-12">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 border-b-2 border-blue-500 pb-2 mb-6">
            Demat PRODUCTS
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {DematProducts.map((product, index) => (
              <motion.div
                key={index}
                className="bg-white shadow-lg rounded-lg p-5 flex flex-col gap-3 transition-all transform hover:scale-105"
                whileHover={{ scale: 1.05 }}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <div className="text-4xl">{product.icon}</div>
                <h3 className="text-lg font-bold text-blue-800">
                  {product.title}
                </h3>
                <p className="text-gray-600">{product.description}</p>
                <a
                  href="#"
                  className="text-blue-600 font-medium flex items-center hover:underline"
                >
                  {product.linkText} →
                </a>
              </motion.div>
            ))}
          </div>
        </section> */}
        <div className="container mx-auto py-2 px-4">
          <h2 className="text-2xl md:text-3xl  font-bold text-center mb-12 text-gray-800">
            Our Featured Products
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {products1.map((product, index) => (
              <motion.a
                href={product.link}
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
                className="bg-blue-50 rounded-2xl p-6 shadow-md hover:shadow-xl text-center relative transition-all duration-300 cursor-pointer no-underline"
              >
                {product.discount && (
                  <div className="absolute top-3 left-3 bg-green-100 text-green-700 text-xs font-semibold px-2 py-1 rounded-md shadow-sm">
                    {product.discount}
                  </div>
                )}
                <div className="text-5xl mb-4">{product.icon}</div>
                <h3 className="text-lg font-semibold text-gray-800">
                  {product.title}
                </h3>
              </motion.a>
            ))}
          </div>
        </div>
        <section className="relative py-10 px-4 bg-white overflow-hidden">
          {/* Background Gradient Blob */}
          <div className="absolute top-0 left-0 w-96 h-96 bg-blue-100 opacity-20 rounded-full blur-[120px] -z-10" />

          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              TheFinMaster Advantage
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto mb-10 leading-relaxed">
              At FinMaster, we believe that financial literacy should be
              accessible, practical, and empowering. Whether you're comparing
              credit cards, choosing insurance, or figuring out the best loan
              for your needs — we simplify the jargon, highlight what really
              matters, and help you make decisions like a pro. With FinMaster,
              you're not just browsing options — you're building confidence in
              your choices.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {pbAdvantages.map((item, index) => (
                <div
                  key={index}
                  className="bg-white border border-gray-100 rounded-xl p-6 flex flex-col items-center text-center shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="mb-4 text-3xl text-blue-600">{item.icon}</div>
                  <h3 className="text-lg font-semibold text-blue-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-gray-500 text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="relative z-10 py-24 px-6 bg-white text-black overflow-hidden mt-2 rounded-t-3xl">
          {/* Background blobs */}
          <div className="absolute top-0 left-0 w-80 h-80 bg-pink-500 opacity-20 rounded-full blur-[120px]" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-indigo-500 opacity-20 rounded-full blur-[120px]" />

          {/* Main Content */}
          <div className="max-w-7xl mx-auto text-center relative z-10">
            <h2 className="text-2xl md:text-3xl font-extrabold bg-gradient-to-r from-blue-500 to-teal-400 text-transparent bg-clip-text mb-16">
              Why Choose Us
            </h2>

            <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3 place-items-center">
              {features.map((item, i) => (
                <motion.div
                  key={i}
                  whileHover={{ scale: 1.05, rotate: 1 }}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className={`relative group bg-gradient-to-br ${item.color} p-1 rounded-3xl w-full max-w-sm shadow-xl hover:shadow-2xl transition-shadow duration-300`}
                >
                  {/* <div className="bg-white rounded-3xl p-6 flex flex-col items-start gap-4 h-full"> */}
                  <div className="bg-white rounded-3xl p-6 flex flex-col items-center text-center gap-4 h-full justify-center">

                    <div className="bg-gray-100 text-black p-3 rounded-full shadow-md">
                      {item.icon}
                    </div>
                    <h3 className="text-xl font-bold">{item.title}</h3>
                    <p className="text-gray-700">{item.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
        <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="5" />
        </div>
          {/* <a
            href={ad2.link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full max-w-[984px]"
          >
            <img
              src={ad2.image}
              alt={ad2.altText}
              className="w-full h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105"
              style={{ aspectRatio: "984 / 410" }}
            />
          </a> */}
        </div>
        {/* <section className="relative z-10 py-24 px-6 bg-gradient-to-br from-gray-950 via-gray-900 to-black text-white overflow-hidden mt-16 rounded-t-3xl">
            
            <div className="absolute -top-1 left-0 w-full overflow-hidden leading-[0] rotate-180">
              <svg
                className="relative block w-[calc(100%+1.3px)] h-12"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                viewBox="0 0 1200 120"
              >
                <path
                  d="M0,0V46.29c47.89,22.28,103.78,38.41,161,48,76.68,12.63,159,15.7,236,2.42,63.88-10.58,127.53-29.36,190-34.79,65.29-5.66,130.18,3.86,193,19.29,60.87,15,117.58,35.26,177,39.88,72.79,5.66,146.68-13.67,213-37.29V0Z"
                  fill="#ffffff"
                ></path>
              </svg>
            </div>

            
            <div className="absolute top-0 left-0 w-80 h-80 bg-pink-500 opacity-20 rounded-full blur-[120px]" />
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-indigo-500 opacity-20 rounded-full blur-[120px]" />

      
            <div className="max-w-7xl mx-auto text-center relative z-10">
              <h2 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-blue-500 to-teal-400 text-transparent bg-clip-text mb-16">
                Why Choose Us
              </h2>

              <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3 place-items-center">
                {features.map((item, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ scale: 1.05, rotate: 1 }}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                    className={`relative group bg-gradient-to-br ${item.color} p-1 rounded-3xl w-full max-w-sm shadow-xl hover:shadow-2xl transition-shadow duration-300`}
                  >
                    <div className="bg-gray-900 rounded-3xl p-6 flex flex-col items-start gap-4 h-full">
                      <div className="bg-white text-black p-3 rounded-full shadow-md">
                        {item.icon}
                      </div>
                      <h3 className="text-xl font-bold">{item.title}</h3>
                      <p className="text-gray-300">{item.desc}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>

          
            <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0]">
              <svg
                className="relative block w-[calc(100%+1.3px)] h-12"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                viewBox="0 0 1200 120"
              >
                <path
                  d="M0,0V46.29c47.89,22.28,103.78,38.41,161,48,76.68,12.63,159,15.7,236,2.42,63.88-10.58,127.53-29.36,190-34.79,65.29-5.66,130.18,3.86,193,19.29,60.87,15,117.58,35.26,177,39.88,72.79,5.66,146.68-13.67,213-37.29V0Z"
                  fill="#ffffff"
                ></path>
              </svg>
            </div>
          </section> */}
        {/* <div className="w-full flex md:py-10 flex-col items-center">
          <div className="w-[90%] flex flex-wrap md:flex-nowrap justify-between py-10">
            <div className="md:w-[40%] flex justify-end items-center md:pr-5">
              <h2 className="font-bold text-3xl md:text-3xl md:w-[85%] text-center md:text-start">
                Embark on financial empowerment by exploring, comparing, and
                making informed decisions with TheFinMaster.
              </h2>
            </div>
            <div className="md:w-[60%]">
              <div className="flex flex-wrap gap-10 md:relative">
                <div className="flex flex-col gap-10">
                  <div className="md:w-[300px] h-[200px] flex items-center justify-center rounded-xl shadow-2xl bg-white">
                    <div className="px-5">
                      <div className="flex items-center gap-2">
                        <GiTakeMyMoney className="text-6xl text-blue-600" />
                        <h3 className="font-bold text-2xl text-gray-600">
                          Financial Hub
                        </h3>
                      </div>
                      <p className="text-gray-500 text-lg pt-2 text-center">
                        Hub of Finance Info: Loans, Cards, Demat, Insurance.
                      </p>
                    </div>
                  </div>

                  <div className="md:w-[300px] h-[200px] flex items-center justify-center rounded-xl hover:shadow-2xl hover:bg-white">
                    <div className="px-5">
                      <div className="flex items-center gap-2">
                        <MdGavel className="text-5xl text-blue-600" />
                        <h3 className="font-bold text-2xl text-gray-600">
                          Smart Decisions
                        </h3>
                      </div>
                      <p className="text-gray-500 text-lg pt-2 text-center">
                        Compare 100+ Products, Make Informed Decisions for
                        Financial Well-being.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-10 md:mt-10">
                  <div className="md:w-[300px] h-[200px] flex items-center justify-center rounded-xl hover:shadow-2xl hover:bg-white">
                    <div className="px-5">
                      <div className="flex items-center gap-2">
                        <FaTools className="text-5xl text-blue-600" />
                        <h3 className="font-bold text-2xl text-gray-600 text-center">
                          Financial Toolbox
                        </h3>
                      </div>
                      <p className="text-gray-500 text-lg pt-2 text-center">
                        Access Tools for Smarter Financial Planning and
                        Management.
                      </p>
                    </div>
                  </div>
                  <div className="md:w-[300px] h-[200px] flex items-center justify-center rounded-xl hover:shadow-2xl hover:bg-white">
                    <div className="px-5">
                      <div className="flex items-center gap-2">
                        <BsFillPersonCheckFill className="text-5xl text-blue-600" />
                        <h3 className="font-bold text-2xl text-gray-600">
                          Expert Insights
                        </h3>
                      </div>
                      <p className="text-gray-500 text-lg pt-2 text-center">
                        Explore Expert Guides for Informed Financial
                        Decision-Making.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>  */}
        <HomeBlog />
           <div className="mt-6 mb-10 grid grid-cols-1 md:grid-cols-3 gap-4 px-16">
                  {/* Financial Tools Tile */}
                  <a 
                    href="/financial-tools-calculators" 
                    className="group bg-gradient-to-br from-blue-600 to-blue-800 hover:from-blue-500 hover:to-blue-700 p-6 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl border border-blue-500/20"
                  >
                    <div className="flex items-center space-x-4">
                      <div className="bg-white/10 p-3 rounded-lg group-hover:bg-white/20 transition-colors">
                        <BsCalculator className="text-2xl text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-white group-hover:text-blue-100">
                          Financial Calculators
                        </h3>
                        <p className="text-blue-100/80 text-sm mt-1 group-hover:text-blue-50">
                          EMI, Mutual Fund & Loan Calculators
                        </p>
                      </div>
                    </div>
                  </a>
        
                  {/* Learning Resources Tile */}
                  <a 
                    href="/blog" 
                    className="group bg-gradient-to-br from-green-600 to-green-800 hover:from-green-500 hover:to-green-700 p-6 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl border border-green-500/20"
                  >
                    <div className="flex items-center space-x-4">
                      <div className="bg-white/10 p-3 rounded-lg group-hover:bg-white/20 transition-colors">
                        <BsBook className="text-2xl text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-white group-hover:text-green-100">
                          Learning Hub
                        </h3>
                        <p className="text-green-100/80 text-sm mt-1 group-hover:text-green-50">
                          Financial guides, tips & insights
                        </p>
                      </div>
                    </div>
                  </a>
        
                  {/* Community Tile */}
                  <a 
                    href="/about" 
                    className="group bg-gradient-to-br from-purple-600 to-purple-800 hover:from-purple-500 hover:to-purple-700 p-6 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl border border-purple-500/20"
                  >
                    <div className="flex items-center space-x-4">
                      <div className="bg-white/10 p-3 rounded-lg group-hover:bg-white/20 transition-colors">
                        <BsPeople className="text-2xl text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-white group-hover:text-purple-100">
                          Join Our Community
                        </h3>
                        <p className="text-purple-100/80 text-sm mt-1 group-hover:text-purple-50">
                          Connect with finance enthusiasts
                        </p>
                      </div>
                    </div>
                  </a>
                </div>
        <Newsletter />
        {/* <div class="px-4 sm:px-8 lg:px-10 mb-8">
                        <div class="w-full py-8 text-white bg-blue-600 rounded-lg shadow-lg">
                            <div class="max-w-[1240px] mx-auto flex flex-col lg:flex-row items-center lg:justify-between">
                                <div class="flex flex-col lg:flex-row items-center mb-4 lg:mb-0 lg:mr-4">
                                    <img src="../assets/newsletter.jpeg" alt="icon" class="w-48 h-40 mb-4 lg:mb-0 lg:mr-4" />
                                    <div class="text-center lg:text-left max-w-full lg:max-w-[60%]">
                                        <h1 class="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 whitespace-normal lg:whitespace-nowrap">
                                            Never miss out on exclusive offers and updates!
                                        </h1>
                                        <p class="text-lg sm:text-xl">Sign up now to receive personalized deals and stay in the loop.</p>
                                    </div>
                                </div>
                                <div class="flex flex-col sm:flex-row items-center w-full lg:w-auto mt-4 lg:mt-20 lg:mr-4">
                                    <input
                                        class="flex-grow lg:flex-grow-0 rounded-md text-black p-2 mb-4 sm:mb-0 sm:mr-4"
                                        type="email"
                                        placeholder="Enter Email"
                                    />
                                    <button class="rounded-md font-medium w-auto lg:w-[200px] px-6 py-3 text-white bg-black hover:bg-gray-900">
                                        Notify Me
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> */}

        {/* <div className="w-full flex flex-col items-center">
          <div className="w-[90%] flex flex-wrap md:flex-nowrap justify-between">
            <div className="w-full">
              <img src="../assets/home1.webp" alt="img1" />
            </div>
            <div className="w-full flex items-center">
              <div>
                <h2 className="font-bold text-3xl">Why TheFinMaster?</h2>
                <li className="flex items-center gap-2">
                  <MdOutlinePermContactCalendar className="text-blue-600" />{" "}
                  Make purchases or withdraw cash from ATMs
                </li>{" "}
                
                <p className="py-5 text-xl font-medium text-gray-600">
                  TheFinMaster.com simplifies your finances! Explore & compare
                  credit cards, loans, insurance & demat accounts from various
                  providers. As a one-stop platform, we aim to simplify your
                  financial journey by providing detailed insights into multiple
                  products and offerings.
                </p>
                <p className="mt-0.5 text-xl font-medium text-gray-600">
                  {" "}
                  Make informed financial decisions with our insightful guides
                  and tools.
                </p>
              </div>
            </div>
          </div>
        </div> */}
        {/* 
        <div className="w-full flex flex-col items-center mt-10 md:mt-0  ">
          <div className="w-[90%] flex flex-wrap md:flex-nowrap justify-between ">
            <div className="w-full md:hidden">
              <img src="../assets/home2.webp" alt="img1" />
            </div>

            <div className="md:w-full flex items-center">
              <div>
                <h2 className="font-bold text-3xl">
                  Master Financial Learning
                </h2>
              
                <p className="py-5  text-xl font-medium text-gray-600">
                  Stay informed and empowered with our insightful blogs. Explore
                  the latest trends, government policies, and financial tips to
                  enhance your financial literacy and make informed decisions.
                </p>
                <p className=" mt-0.5 text-xl font-medium text-gray-600">
                  {" "}
                  Dive into our blogs and enrich your financial knowledge today!
                </p>
              
              </div>
            </div>
            <div className="md:w-full hidden md:block">
              <img src="../assets/home2.webp" alt="img2" />
            </div>
          </div>
        </div> */}

        {/* <h1 className='text-center font-bold text-3xl md:text-5xl my-10 mt-20'>Featured Credit Cards</h1>
                    <div className='w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center'>
                        <div className='w-fit flex flex-col gap-8'>
                            {
                                currentCards &&
                                currentCards.map((item, index) => {
                                    return <> <CardComponent key={index} Card_features={item?.Card_features} fees={item?.fees} cardName={item?.title} cardImage={item?.image} rating={item?.rating} category={item?.category} status={item?.status} /> </>
                                })
                            }   </div>

                        <div className='w-full relative '>
                            <div className='sticky overflow-hidden top-20 shadow-lg w-full h-[230px] rounded-2xl bg-blue-500 border flex flex-col justify-between'>
                                <div className='w-[70%] mx-auto'>
                                    <h2 className='text-center font-medium pt-5 text-lg'><span className='font-semibold text-white'>816 people</span> are on call with our advisors right now</h2>
                                </div>
                                <div className='w-full mx-auto'>
                                    <div className='w-[70%] mx-auto'>
                                        <img src='https://static.pbcdn.in/health-cdn/images/insurer-logo/quotes-logos/advisors-logo.png' alt='imgg' />
                                    </div>
                                    <div className='bg-white'>
                                        <h3 className='text-center text-blue-500 cursor-pointer font-semibold py-2'>Know your advisor</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <ul className='flex justify-center mt-4'>
                        {currentCards &&
                            CreditCardData.cards?.filter((card) => card.category === "Credit card").length > 0 &&
                            Math.ceil(CreditCardData.cards?.filter((card) => card.category === "Credit card").length / cardsPerPage) > 1 &&
                            Array.from({ length: Math.ceil(CreditCardData.cards?.filter((card) => card.category === "Credit card").length / cardsPerPage) }).map((_, index) => (
                                <li key={index} className='mx-1'>
                                    <button
                                        className={`px-3 py-1 rounded-lg ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
                                            }`}
                                        onClick={() => paginate(index + 1)}
                                    >
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                    </ul>

                    <div className='w-full my-20'>
                        <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
                            <h1 className='text-white text-3xl md:text-7xl text-centerz-20 font-medium'>
                                Personal Loan
                            </h1>
                            <p className='text-gray-200 text-2xl text-center md:text-start px-2 pt-2'>Unlock your financial potential with our personalized personal loan solutions.</p> */}
        {/* <img className='w-[100%] h-[100%] object-cover' src='https://www.kotak.com/content/dam/Kotak/guidance/hero-slider-banner/hacks-for-being-regular-with-personal-loan-repayments-hero-desktop.jpg' alt='personalLoan' /> */}
        {/* </div> */}

        {/* 
                        <div className='w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center'>
                            <div className='w-fit flex flex-col gap-8 mt-5'>
                                {currentCards_Personal &&
                                    currentCards_Personal.map((item, index) => (
                                        <LoanCardComponent
                                            key={index}
                                            Card_features={item?.Card_features}
                                            fees={item?.fees}
                                            cardName={item?.title}
                                            cardImage={item?.image}
                                            rating={item?.rating}
                                            category={item?.category}

                                        />
                                    ))}
                            </div> */}

        {/* <div className='w-full relative mt-5'>
                                <div className='sticky overflow-hidden top-5 shadow-lg w-full rounded-lg bg-blue-500 border flex flex-col justify-between'> */}

        {/* <div className='w-full mx-auto'>
                                        <div className='w-full mx-auto'>
                                            <img src='https://creditloanz.com/wp-content/uploads/2022/12/HDFC-Bank-Personal-Loan.png' alt='imgg' />
                                        </div>
                                        <div className='bg-white'>
                                            <h3 className='text-center text-blue-500 cursor-pointer font-semibold py-2'>Know your advisor</h3>
                                        </div>
                                    </div> */}
        {/* </div>
                        </div> 
                        </div> */}
        {/* Pagination */}
        {/* <ul className='flex justify-center mt-4'>
    {cardsPerPage_Personal &&
        CreditCardData.cards?.filter((card) => card.category === "Loan").length > 0 &&
        Math.ceil(CreditCardData.cards?.filter((card) => card.category === "Loan").length / cardsPerPage_Personal) > 1 &&
        Array.from({ length: Math.ceil(CreditCardData.cards?.filter((card) => card.category === "Loan").length / cardsPerPage_Personal) }).map((_, index) => (
            <li key={index} className='mx-1'>
                <button
                    className={`px-3 py-1 rounded-lg ${currentPage_Personal === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
                        }`}
                    onClick={() => paginatePersonal(index + 1)}
                >
                    {index + 1}
                </button>
            </li>
        ))}
</ul> */}

        {/* <h1 className='my-5 text-center text-4xl font-extrabold'>PERSONAL LOAN</h1> */}
        {/* <h4 className='mt-20 mb-5 text-center text-3xl text-blue-900 font-bold underline'>COMPARISON</h4>
                        <div className='w-[90%] mx-auto'>
                            <table className="min-w-full table-auto">
                                <thead className='sticky top-0'>
                                    <tr>
                                        <th className="px-4 py-3 bg-blue-900 text-white"></th>
                                        <th className="px-4 py-3 bg-blue-900 text-white">Bank Name</th>
                                        <th className="px-4 py-3 bg-blue-900 text-white">Interest Range</th>
                                        <th className="px-4 py-3 bg-blue-900 text-white">Loan Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        LoanData && LoanData.map((item, index) => {
                                            return <tr key={index} className='even:bg-gray-100 border hover:bg-blue-100'>
                                                <td className="font-medium text-center px-4 py-5">{index + 1}</td>
                                                <td className="font-medium text-center px-4 py-5">{item.Bank_Name}</td>
                                                <td className="text-center px-4 py-5">{item.Interest_Range}</td>
                                                <td className="text-center px-4 py-5">{item.Loan_Amount}</td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div> */}
      </div>

      <div className="w-[95%] mx-auto py-10">
        <h3 className="text-center font-bold text-2xl md:text-3xl my-10">
          Frequently Asked Questions
        </h3>
        <AccordionComponent />
      </div>
      {/* </div> */}

      {/* <FooterComponent /> */}
      {/* </div> */}
    </>
  );
};

export default Home;
